import React from 'react';

export interface ConditionalWrapperProps {
  /**
   * Children to be wrapped
   */
  children: React.ReactNode;
  /**
   * Condition to determine if the children should be wrapped
   */
  condition: boolean;
  /**
   * Function that wraps the children
   */
  wrapper: (children: React.ReactNode) => React.ReactNode;
}

/**
 * Utility to conditionally wrap children with a wrapper function
 */
export const ConditionalWrapper: React.FC<ConditionalWrapperProps> = ({ condition, wrapper, children }) =>
  condition ? wrapper(children) : children;
